export default "__VITE_ASSET__B6t2elOR__"